import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

const useIsComDomain = () => {
  const history = useHistory();
  const [isComDomain, setIsComDomain] = useState(window.location.hostname.endsWith('.com'));

  const checkDomain = () => {
    const hostname = window.location.hostname;
    setIsComDomain(hostname.endsWith('.com'));
  };

  useEffect(() => {
    checkDomain();

    const unlisten = history.listen(() => {
      checkDomain();
    });

    return () => {
      unlisten();
    };
  }, [history]);

  return isComDomain;
};

export default useIsComDomain;
